import { Request } from '../../../../httpClient/serverApi/requests/Request';

export interface IResetServerSettingsParams {
}

export interface IResetServerSettingsResult {
}

export class ResetServerSettingsRequest extends Request<IResetServerSettingsParams, IResetServerSettingsResult> {
  constructor(params: IResetServerSettingsParams = {}) {
    super('resetServerSettings', params);
  }
}
